import { AnimatedSidebar } from "../../../components/interactives";
import { Button } from "../../../components/basics/Button";
import { ButtonType } from "../../../helpers/shared/buttonStyling";

interface IProps {
  show: boolean;
  onClose: () => void;
}

export const CompanyDomicileInfo = ({ show, onClose }: IProps) => {
  return (
    <AnimatedSidebar show={show} onClose={onClose}>
      <div className="px-6 md:pt-14 md:px-18">
        <h2 className="text-xl font-bold mb-4">Company is domiciled in</h2>
        <p>If the policyholder has multiple offices, input the Head office location.</p>
        <Button className="mt-10" type={ButtonType.PRIMARY} htmlType="button" onClick={onClose}>
          Back
        </Button>
      </div>
    </AnimatedSidebar>
  );
};
